import React from "react";
import ReactTooltip from "react-tooltip";

export default function TickerModalHeader(props) {
  //Longbow Core Signal 'bars'
  const displayBar = () => {
    let signalStrength = 0;
    if (props.algo.data.CALC_POSITION_LONGBOW_SIGNAL_STRENGTH) {
      signalStrength = Math.round(
        props.algo.data.CALC_POSITION_LONGBOW_SIGNAL_STRENGTH * 10,
      );
      if (signalStrength >= 10) {
        signalStrength = 9;
      }
    }
    const signalColor = (index) => {
      let primaryColor = "#ffffff";
      let halfColor = "linear-gradient(#3E3E3E 50%, #ffffff 50%)";
      let neutralColor = "#3E3E3E";

      if (props.algo.data["CALC_POSITION_LONGBOW_SIGNAL"] === "Buy") {
        primaryColor = "#75CE41";
        halfColor = "linear-gradient(#3E3E3E 50%, #75CE41 50%)";
        neutralColor = "#3E3E3E";
      }
      if (props.algo.data["CALC_POSITION_LONGBOW_SIGNAL"] === "Sell") {
        primaryColor = "#D33541";
        halfColor = "linear-gradient(#57262B 50%, #D33541 50%)";
        neutralColor = "#57262B";
      }
      const style = [
        [neutralColor, neutralColor, neutralColor, neutralColor, neutralColor],
        [halfColor, neutralColor, neutralColor, neutralColor, neutralColor],
        [primaryColor, neutralColor, neutralColor, neutralColor, neutralColor],
        [primaryColor, halfColor, neutralColor, neutralColor, neutralColor],
        [primaryColor, primaryColor, neutralColor, neutralColor, neutralColor],
        [primaryColor, primaryColor, halfColor, neutralColor, neutralColor],
        [primaryColor, primaryColor, primaryColor, neutralColor, neutralColor],
        [primaryColor, primaryColor, primaryColor, halfColor, neutralColor],
        [primaryColor, primaryColor, primaryColor, primaryColor, neutralColor],
        [primaryColor, primaryColor, primaryColor, primaryColor, halfColor],
        [primaryColor, primaryColor, primaryColor, primaryColor, primaryColor],
      ][signalStrength];
      return style[index];
    };
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-end",
          justifyContent: "space-around",
          width: 40,
        }}
      >
        <div
          style={{
            height: 10,
            width: 5,
            backgroundImage: signalColor(0).startsWith("l")
              ? signalColor(0)
              : "unset",
            backgroundColor:
              (Math.max(props.algo.data["CALC_TRADE_RANGE_LOW"]) !== -1) &
              (Math.max(props.algo.data["CALC_TRADE_RANGE_HIGH"]) !== -1)
                ? signalColor(0)
                : "#3e3e3e",
            borderRadius: 20,
          }}
        ></div>
        <div
          style={{
            height: 15,
            width: 5,
            backgroundImage: signalColor(1).startsWith("l")
              ? signalColor(1)
              : "unset",
            backgroundColor:
              (Math.max(props.algo.data["CALC_TRADE_RANGE_LOW"]) !== -1) &
              (Math.max(props.algo.data["CALC_TRADE_RANGE_HIGH"]) !== -1)
                ? signalColor(1)
                : "#3e3e3e",
            borderRadius: 20,
          }}
        ></div>
        <div
          style={{
            height: 20,
            width: 5,
            backgroundImage: signalColor(2).startsWith("l")
              ? signalColor(2)
              : "unset",
            backgroundColor:
              (Math.max(props.algo.data["CALC_TRADE_RANGE_LOW"]) !== -1) &
              (Math.max(props.algo.data["CALC_TRADE_RANGE_HIGH"]) !== -1)
                ? signalColor(2)
                : "#3e3e3e",
            borderRadius: 20,
          }}
        ></div>
        <div
          style={{
            height: 25,
            width: 5,
            backgroundImage: signalColor(3).startsWith("l")
              ? signalColor(3)
              : "unset",
            backgroundColor:
              (Math.max(props.algo.data["CALC_TRADE_RANGE_LOW"]) !== -1) &
              (Math.max(props.algo.data["CALC_TRADE_RANGE_HIGH"]) !== -1)
                ? signalColor(3)
                : "#3e3e3e",
            borderRadius: 20,
          }}
        ></div>
        <div
          style={{
            height: 30,
            width: 5,
            backgroundImage: signalColor(4).startsWith("l")
              ? signalColor(4)
              : "unset",
            backgroundColor:
              (Math.max(props.algo.data["CALC_TRADE_RANGE_LOW"]) !== -1) &
              (Math.max(props.algo.data["CALC_TRADE_RANGE_HIGH"]) !== -1)
                ? signalColor(4)
                : "#3e3e3e",
            borderRadius: 20,
          }}
        ></div>
      </div>
    );
  };

  const priceChange =
    parseFloat(props.original.px_last.replace(/,/g, "")) -
    parseFloat(props.original.px_close_1d.replace(/,/g, ""));
  const percentChange =
    (parseFloat(props.original.px_last.replace(/,/g, "")) -
      parseFloat(props.original.px_close_1d.replace(/,/g, ""))) /
    parseFloat(props.original.px_close_1d.replace(/,/g, ""));
  return (
    <div>
      <div>
        <div
          style={{
            padding: 7,
            color: "white",
            background: "#222222",
          }}
        >
          {/* Stock Split Filter Icon */}
          <span style={{ marginLeft: 15 }}>
            {props.original.name} - {props.cell.row.cells[0].value}
          </span>
          {props.beforeSplit > 0 || props.afterSplit > 0 ? (
            <span style={{ cursor: "pointer" }}>
              <span
                style={{
                  border: ".5px solid #75ce41",
                  borderRadius: "45%",
                  padding: "1px 3.5px",
                  fontSize: "6px",
                  backgroundColor: "#222222",
                  color: "#75ce41",
                  marginLeft: 10,
                  position: "relative",
                  bottom: 3,
                }}
              >
                <i class="fa fa-dollar-sign"></i>
              </span>
              <span
                data-tip={`${props.cell.row.cells[0].value} 
                ${props.beforeSplit > 0 ? "will" : ""} split on 
                ${props.ratio} on 
                ${new Intl.DateTimeFormat("en-US", {
                  timeZone: "UTC",
                  year: "numeric",
                  month: "long",
                  day: "2-digit",
                }).format(new Date(props ? props.split : null))}.`}
                style={{
                  border: ".5px solid #75ce41",
                  borderRadius: "45%",
                  padding: "1px 3.5px",
                  fontSize: "6px",
                  backgroundColor: "#222222",
                  color: "#75ce41",
                  position: "relative",
                  top: 1,
                  right: 5,
                }}
              >
                <i class="fa fa-dollar-sign"></i>
              </span>
            </span>
          ) : null}
        </div>
      </div>
      <div
        className="modal-header"
        style={{ borderTop: "1px solid #2e2e2e", height: 75 }}
      >
        <div className="header-info">
          <div
            onClick={() => props.setChartDisplay("Price-Chart")}
            className="header-section price-section"
            style={{
              display: "inline",
              padding: 10,
              background:
                props.chartDisplay === "Price-Chart" ? "#171717" : null,
              cursor: "pointer",
              borderBottom: "1px solid #2e2e2e",
            }}
          >
            <div>
              <div
                className="price"
                style={{
                  padding: "0px 0px 2px 20px",
                  position: "inline-block",
                }}
              >
                {`Last\nPrice`}
              </div>
              <span
                data-multiline={true}
                data-tip={`The most recent price of a security captured by Longbow.`}
                className="info-icon"
                style={{
                  fontWeight: 100,
                  position: "absolute",
                  top: "15px",
                  left: "90px",
                  color: "white",
                }}
              >
                i
              </span>
              {/* Closing/Last Price section */}
              <div
                style={{
                  display: "flex",
                  fontSize: 8,
                  color: "#BBB8B8",
                  textAlign: "center",
                }}
              >
                <div style={{ width: "33%" }}>
                  <div>{`Last`}</div>
                </div>
                <div style={{ width: "33%" }}>
                  <div>$ Chg</div>
                </div>
                <div style={{ width: "33%" }}>
                  <div>% Chg</div>
                </div>
              </div>
            </div>
            <div className="price-info" style={{ padding: 0 }}>
              <i
                style={{ left: 18 - props.original.px_last * 2 }}
                className={
                  priceChange < 0
                    ? "fas fa-sort-down price-icon-down"
                    : "fas fa-sort-up price-icon"
                }
              />
              <div
                style={{ display: "flex", textAlign: "center", fontSize: 11 }}
              >
                <div
                  style={{
                    color: priceChange < 0 ? "#d33541" : "#75ce41",
                    width: "33%",
                  }}
                >
                  {/* if price is >= $100,000, remove decimal to preserve space */}
                  {props.original.px_last || props.original.px_last > 0
                    ? props.original.px_last >= 10
                      ? props.original.px_last.substring(
                          0,
                          props.original.px_last - 3,
                        )
                      : props.original.px_last
                    : "- - -"}
                </div>
                <div
                  style={{
                    width: "33%",
                    color: priceChange < 0 ? "#d33541" : "#75ce41",
                  }}
                >
                  {props.original.px_close_1d
                    ? props.usdCurrency(Math.abs(priceChange))
                    : "- - -"}
                </div>
                <div
                  style={{
                    color: priceChange < 0 ? "#d33541" : "#75ce41",
                    width: "33%",
                  }}
                >
                  {percentChange ? percentChange.toFixed(2) + "%" : "- - -"}
                </div>
              </div>
            </div>
          </div>
          {/* TRADING RANGE section */}
          <div
            className="header-section trading-range"
            style={{
              background:
                props.chartDisplay === "Trading-Range-Chart" ? "#171717" : null,
              padding: 10,
              borderBottom: "1px solid #2e2e2e",
            }}
            onClick={() => props.setChartDisplay("Trading-Range-Chart")}
          >
            <div
              className="trading-range-title"
              style={{ padding: "0px 0px 0px 10px", top: 34 }}
            >
              Trading Range
            </div>
            <div
              className="floating-text"
              style={{ right: 20, top: 15, color: "#BBB8B8" }}
            >
              % from Trading Range
            </div>
            <div
              className="trading-range-info"
              style={{ right: 0, top: 35, color: "#BBB8B8" }}
            >
              <div className="range-info">
                <div className="range-title" style={{ color: "#BBB8B8" }}>
                  Low
                </div>
                <div className="range-number">
                  <span>
                    {/* Low */}
                    <span
                      style={
                        props.algo.data["CALC_TRADE_RANGE_LOW"] && {
                          color: "#75CE41",
                        }
                      }
                    >
                      {props.algo.data["CALC_TRADE_RANGE_LOW"] &&
                      (Math.max(props.algo.data["CALC_TRADE_RANGE_LOW"]) !==
                        -1) &
                        (Math.max(props.algo.data["CALC_TRADE_RANGE_HIGH"]) !==
                          -1)
                        ? props.algo.data["CALC_TRADE_RANGE_LOW"] >= 10000
                          ? props.noDecimals(
                              props.algo.data["CALC_TRADE_RANGE_LOW"],
                            )
                          : props.usCurrency(
                              props.algo.data["CALC_TRADE_RANGE_LOW"],
                              props.original,
                            )
                        : "- - -"}
                    </span>
                  </span>
                </div>
              </div>
              <div className="range-info">
                <div className="range-title" style={{ color: "#BBB8B8" }}>
                  High
                </div>
                <div className="range-number">
                  <span>
                    {/* High */}
                    <span
                      style={
                        props.algo.data["CALC_TRADE_RANGE_HIGH"] && {
                          color: "#D33541",
                        }
                      }
                    >
                      {props.algo.data["CALC_TRADE_RANGE_HIGH"] &&
                      (Math.max(props.algo.data["CALC_TRADE_RANGE_HIGH"]) !==
                        -1) &
                        (Math.max(props.algo.data["CALC_TRADE_RANGE_LOW"]) !==
                          -1)
                        ? props.algo.data["CALC_TRADE_RANGE_HIGH"] >= 10000
                          ? props.noDecimals(
                              props.algo.data["CALC_TRADE_RANGE_HIGH"],
                            )
                          : props.usCurrency(
                              props.algo.data["CALC_TRADE_RANGE_HIGH"],
                              props.original,
                            )
                        : "- - -"}
                    </span>
                  </span>
                </div>
              </div>
              {/* Range Signal */}
              <div className="pill-container">
                <div
                  className={`indicator-pill 
                  ${
                    props.algo.data["CALC_TRADE_RANGE_HIGH"] === null ||
                    (props.algo.data["CALC_TRADE_RANGE_LOW"] === null) &
                      (Math.max(props.algo.data["CALC_TRADE_RANGE_HIGH"]) ===
                        -1) ||
                    Math.max(props.algo.data["CALC_TRADE_RANGE_LOW"]) === -1
                      ? "empty-value"
                      : props.algo.data["CALC_TRADING_RANGE_SIGNAL"] === "Buy"
                      ? "green"
                      : props.algo.data["CALC_TRADING_RANGE_SIGNAL"] === "Sell"
                      ? "red"
                      : props.algo.data["CALC_TRADING_RANGE_SIGNAL"] === "Hold"
                      ? "grey"
                      : "empty-value"
                  }-background`}
                >
                  <span>
                    {props.algo.data["CALC_TRADING_RANGE_SIGNAL"] &&
                    (props.algo.data["CALC_TRADE_RANGE_HIGH"] != null) &
                      (props.algo.data["CALC_TRADE_RANGE_LOW"] != null) &
                      (Math.max(props.algo.data["CALC_TRADE_RANGE_HIGH"]) !==
                        -1) &
                      (Math.max(props.algo.data["CALC_TRADE_RANGE_LOW"]) !== -1)
                      ? props.algo.data["CALC_TRADING_RANGE_SIGNAL"] === "Buy"
                        ? "Oversold"
                        : props.algo.data["CALC_TRADING_RANGE_SIGNAL"] ===
                          "Sell"
                        ? "Overbought"
                        : "Neutral"
                      : "- - -"}
                  </span>
                </div>
              </div>
              <div className="range-info">
                <div className="range-title" style={{ color: "#BBB8B8" }}>
                  Low
                </div>
                {/* % Low */}
                <div
                  className={
                    (!props.algo.data["CALC_TRADE_RANGE_PERCENT_LOW"] &&
                      props.algo.data["CALC_TRADE_RANGE_HIGH"] === null) ||
                    props.algo.data["CALC_TRADE_RANGE_LOW"] === null ||
                    Math.max(props.algo.data["CALC_TRADE_RANGE_HIGH"]) === -1 ||
                    Math.max(props.algo.data["CALC_TRADE_RANGE_LOW"]) === -1
                      ? "range-number empty-value"
                      : "range-number red"
                  }
                >
                  <span>
                    {props.algo.data["CALC_TRADE_RANGE_PERCENT_LOW"] &&
                    (props.algo.data["CALC_TRADE_RANGE_HIGH"] != null) &
                      (props.algo.data["CALC_TRADE_RANGE_LOW"] != null) &
                      (Math.max(props.algo.data["CALC_TRADE_RANGE_HIGH"]) !==
                        -1) &
                      (Math.max(props.algo.data["CALC_TRADE_RANGE_LOW"]) !== -1)
                      ? props.algo.data["CALC_TRADE_RANGE_PERCENT_LOW"]
                      : "- - -"}
                  </span>
                </div>
              </div>
              <div className="range-info">
                <div className="range-title" style={{ color: "#BBB8B8" }}>
                  High
                </div>
                {/* % High */}
                <div
                  className={
                    (!props.algo.data["CALC_TRADE_RANGE_PERCENT_HIGH"] &&
                      props.algo.data["CALC_TRADE_RANGE_HIGH"] === null) ||
                    props.algo.data["CALC_TRADE_RANGE_LOW"] === null ||
                    Math.max(props.algo.data["CALC_TRADE_RANGE_HIGH"]) === -1 ||
                    Math.max(props.algo.data["CALC_TRADE_RANGE_LOW"]) === -1
                      ? "range-number empty-value"
                      : "range-number green"
                  }
                >
                  <span>
                    {props.algo.data["CALC_TRADE_RANGE_PERCENT_HIGH"] &&
                    (props.algo.data["CALC_TRADE_RANGE_HIGH"] != null) &
                      (props.algo.data["CALC_TRADE_RANGE_LOW"] != null) &
                      (Math.max(props.algo.data["CALC_TRADE_RANGE_HIGH"]) !==
                        -1) &
                      (Math.max(props.algo.data["CALC_TRADE_RANGE_LOW"]) !== -1)
                      ? props.algo.data["CALC_TRADE_RANGE_PERCENT_HIGH"]
                      : "- - -"}
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* LONGBOW CORE SIGNAL section */}
          <div
            className="longbow-overall-signal"
            style={{
              borderRight: "1px solid #2e2e2e",
              padding: 10,
              borderBottom: "1px solid #2e2e2e",
            }}
          >
            <div className="long-bow-text" style={{ textAlign: "center" }}>
              Longbow Core Signal
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                padding: "0px 20px",
              }}
            >
              <div
                className={`indicator-pill 
                ${
                  Math.max(props.algo.data["CALC_TRADE_RANGE_HIGH"]) === -1 ||
                  Math.max(props.algo.data["CALC_TRADE_RANGE_LOW"]) === -1
                    ? "empty-value"
                    : props.algo.data["CALC_POSITION_LONGBOW_SIGNAL"] === "Buy"
                    ? "green"
                    : props.algo.data["CALC_POSITION_LONGBOW_SIGNAL"] === "Sell"
                    ? "red"
                    : props.algo.data["CALC_POSITION_LONGBOW_SIGNAL"] === "Hold"
                    ? "grey"
                    : "empty-value"
                }-background`}
                style={{ marginTop: 7 }}
              >
                <span>
                  {Math.max(props.algo.data["CALC_TRADE_RANGE_HIGH"]) === -1 ||
                  Math.max(props.algo.data["CALC_TRADE_RANGE_LOW"]) === -1
                    ? "- - -"
                    : props.algo.data["CALC_POSITION_LONGBOW_SIGNAL"] === "Buy"
                    ? "Long"
                    : props.algo.data["CALC_POSITION_LONGBOW_SIGNAL"] === "Sell"
                    ? "Short"
                    : props.algo.data["CALC_POSITION_LONGBOW_SIGNAL"] === "Hold"
                    ? "Neutral"
                    : "- - -"}
                </span>
              </div>
              <div>{displayBar()}</div>
            </div>
          </div>
          {/* ODDS section */}
          <div
            className="header-section trade-odds"
            style={{ padding: 10, borderBottom: "1px solid #2e2e2e" }}
          >
            <div className="odds" style={{ position: "relative", top: 10 }}>
              <div style={{ position: "relative", top: -5 }}>
                <div className="odds-text" style={{ color: "#BBB8B8" }}>
                  Range
                </div>
                <div className="odds-text" style={{ color: "#BBB8B8" }}>
                  Odds
                </div>
              </div>
              <div
                className="odds-number"
                style={{
                  color:
                    props.algo.data["CALC_TRADE_RANGE_ODDS"] > 0 &&
                    (props.algo.data["CALC_TRADE_RANGE_HIGH"] != null) &
                      (props.algo.data["CALC_TRADE_RANGE_LOW"] != null) &
                      (Math.max(props.algo.data["CALC_TRADE_RANGE_HIGH"]) !==
                        -1) &
                      (Math.max(props.algo.data["CALC_TRADE_RANGE_LOW"]) !== -1)
                      ? "#75ce41"
                      : props.algo.data["CALC_TRADE_RANGE_ODDS"] < 0
                      ? "#d33541"
                      : "#666666",
                }}
              >
                <span>
                  {props.algo.data["CALC_TRADE_RANGE_ODDS"] &&
                  (props.algo.data["CALC_TRADE_RANGE_HIGH"] != null) &
                    (props.algo.data["CALC_TRADE_RANGE_LOW"] != null) &
                    (Math.max(props.algo.data["CALC_TRADE_RANGE_HIGH"]) !==
                      -1) &
                    (Math.max(props.algo.data["CALC_TRADE_RANGE_LOW"]) !== -1)
                    ? props.algo.data["CALC_TRADE_RANGE_ODDS"].toFixed(2)
                    : "- - -"}
                </span>
                {props.algo.data["CALC_TRADE_RANGE_ODDS"] > 0 &&
                (props.algo.data["CALC_TRADE_RANGE_HIGH"] != null) &
                  (props.algo.data["CALC_TRADE_RANGE_LOW"] != null) &
                  (Math.max(props.algo.data["CALC_TRADE_RANGE_HIGH"]) !== -1) &
                  (Math.max(props.algo.data["CALC_TRADE_RANGE_LOW"]) !== -1) ? (
                  <i
                    className="fas fa-caret-up"
                    style={{
                      position: "relative",
                      left: 2,
                      top: -2.5,
                      fontSize: 20.5,
                    }}
                  />
                ) : props.algo.data["CALC_TRADE_RANGE_ODDS"] < 0 ? (
                  <i
                    className="fas fa-caret-down"
                    style={{
                      position: "relative",
                      left: 2,
                      top: -3.5,
                      fontSize: 20.5,
                    }}
                  />
                ) : null}
              </div>
            </div>
          </div>
          {/* BETA section */}
          <div
            className="header-section beta"
            onClick={() => props.setChartDisplay("Beta-Chart")}
            style={{
              padding: 10,
              borderBottom: "1px solid #2e2e2e",
              cursor: "pointer",
              background:
                props.chartDisplay === "Beta-Chart" ? "#171717" : null,
            }}
          >
            <div className="beta-text" style={{ paddingTop: 0 }}>
              Beta
            </div>
            <div
              className="beta-sub-text"
              style={{ paddingTop: 8, color: "#BBB8B8" }}
            >
              TTM
            </div>
            <div
              className={`beta-number ${
                props.cell.row.original.eqy_beta ? "grey" : "empty-value"
              }`}
              style={{ paddingTop: 10, color: "#ffffff" }}
            >
              {props.original.eqy_beta ? props.original.eqy_beta : "- - -"}
            </div>
          </div>
        </div>
        <i
          onClick={() => props.clickModal()}
          className="fas fa-times close-icon"
        ></i>
      </div>
      <ReactTooltip place="right" />
    </div>
  );
}
